import {
  billingBundleCatalogProductSchema,
  billingBundleSchema,
  type BillingBundle,
  type BillingBundleCatalogProduct,
} from "@redotech/redo-billing-common/billing-bundle";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export interface GetTeamBillingBundlesInput {
  teamId: string;
}
export interface GetTeamBillingBundlesOutput {
  products: BillingBundleCatalogProduct[];
  bundles: BillingBundle[];
}
export interface UpdateTeamBillingBundlesInput {
  teamId: string;
  bundles: BillingBundle[];
}
export interface UpdateTeamBillingBundlesOutput {
  bundles: BillingBundle[];
}

export const getTeamBillingBundles = unaryRpc<
  "getTeamBillingBundles",
  GetTeamBillingBundlesInput,
  GetTeamBillingBundlesOutput
>({
  name: "getTeamBillingBundles",
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    products: z.array(billingBundleCatalogProductSchema),
    bundles: z.array(billingBundleSchema),
  }),
});

export const updateTeamBillingBundles = unaryRpc<
  "updateTeamBillingBundles",
  UpdateTeamBillingBundlesInput,
  UpdateTeamBillingBundlesOutput
>({
  name: "updateTeamBillingBundles",
  input: z.object({
    teamId: zExt.objectId(),
    bundles: z.array(billingBundleSchema),
  }),
  output: z.object({ bundles: z.array(billingBundleSchema) }),
});
